/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Icons, CustomValidation, Button, FlexRow, FlexCol } from 'sarsaparilla';

const propTypes = {
  index: PropTypes.number,
  removeLeader: PropTypes.func,
  leader: PropTypes.shape({
    first_name: PropTypes.string,
    email: PropTypes.string,
    cell_phone: PropTypes.string,
    last_name: PropTypes.string
  }),
  className: PropTypes.string,
  alternateLeaderValidatorMethod: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  pActions: PropTypes.shape().isRequired,
  reservationId: PropTypes.string
};

const defaultProps = {
  isDisabled: false,
  className: ''
};

export default class AlternatePermitHolderNamePhoneEntry extends React.Component {
  constructor(props) {
    super(props);
    this.onClickRemove = this.onClickRemove.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onClickRemove() {
    const index = parseInt(this.props.index, 10);
    this.props.removeLeader(index);
  }

  handleChange(event) {
    const input = event.target.value;
    const key = event.target.name;
    const path = `alt_permit_holders[${this.props.index}].${key}`;
    this.props.pActions.updatePendingReservation(this.props.reservationId, path, input);
  }

  handleValidation(key, isInvalid, error) {
    const path = `${this.props.reservationId}_alt_permit_holders[${this.props.index}].${key}`;

    if (isInvalid) {
      this.props.pActions.formValidationChange(path, error);
    } else {
      this.props.pActions.formValidationChange(path, null);
    }
  }

  nameValidatorMethod(value) {
    return isEmpty(value);
  }

  renderRemoveLeaderButton() {
    if (this.props.isDisabled) {
      return <div />;
    }

    return (
      <div className="alternate-group-leader">
        <Button
          type="button"
          className="remove-leader-link"
          onClick={this.onClickRemove}
          iconBeforeElement={<Icons.IconCloseCircle />}
          screenReaderTextBefore="Close" />
      </div>
    );
  }

  render() {
    const { leader } = this.props;
    return (
      <div className="permit-alt-input-wrap m-1">
        <div className="permit-alt-header-wrap">
          <div className="permit-alt-header">Alternate Permit Holder #{this.props.index + 1}</div>
          {this.renderRemoveLeaderButton()}
        </div>

        <FlexRow className="mb-1">
          <FlexCol xs={12} md={6} lg={4}>
            <label htmlFor="other-first_name">First Name</label>
            <input
              id="other-first_name"
              type="text"
              name="first_name"
              className={this.props.className}
              value={get(leader, 'first_name', '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, 'first_name', '')}
              displayInSummary
              customValidator={this.nameValidatorMethod}
              onValidated={this.handleValidation.bind(this, 'first_name')}
              controlLabel="Alternate Permit Holder First Name" />
          </FlexCol>
          <FlexCol xs={12} md={6} lg={4}>
            <label htmlFor="other-last_name">Last Name</label>
            <input
              id="other-last_name"
              type="text"
              name="last_name"
              className={this.props.className}
              value={get(leader, 'last_name', '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, 'last_name', '')}
              displayInSummary
              customValidator={this.nameValidatorMethod}
              onValidated={this.handleValidation.bind(this, 'last_name')}
              controlLabel="Alternate Permit Holder Last Name" />
          </FlexCol>
          <FlexCol xs={12} md={12} lg={4}>
            <label htmlFor="other-phone">Phone</label>
            <input
              id="other-phone"
              type="text"
              name="cell_phone"
              className={this.props.className}
              value={get(leader, 'cell_phone', '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, 'cell_phone', '')}
              displayInSummary
              customValidator={this.props.alternateLeaderValidatorMethod}
              onValidated={this.handleValidation.bind(this, 'cell_phone')}
              controlLabel="Alternate Permit Holder Phone" />
          </FlexCol>
        </FlexRow>
      </div>
    );
  }
}

AlternatePermitHolderNamePhoneEntry.propTypes = propTypes;
AlternatePermitHolderNamePhoneEntry.defaultProps = defaultProps;
